module.exports = __webpack_public_path__ + "static/media/doubt.5dbcbad3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/doubt.svg
// module id = 720
// module chunks = 0